import { RowLabelsCompanyDto } from "@/dtos";
import { Company, LabelCompany } from "@/entities";

export const formatRowLabelsCompany = (passengerGroupCompanies: LabelCompany[], companies: Company[]): RowLabelsCompanyDto[] => {
    return passengerGroupCompanies.map((r) => {
        const company = companies.find((c) => c.id === r.company_id);
        const row: RowLabelsCompanyDto = {
            ...r,
            company_id: r.company_id,
            company: company?.name ?? '',
            is_active: r.is_active,
            active: r.is_active ? 'Activo' : 'Inactivo'
        }
        return row;
    });
}